module.exports = __webpack_public_path__ + "img/5.45a2e85e.jpg";